import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App';
// Microsoft Clarity
const clarityScript = document.createElement('script');
clarityScript.async = true;
clarityScript.src = 'https://www.clarity.ms/tag/wdj4p77ads';
document.head.appendChild(clarityScript);
(window as any).clarity = (window as any).clarity || function () {
  ;
  ((window as any).clarity.q = (window as any).clarity.q || []).push(arguments);
};
(function (f: any, b: any, e: string, v: string) {
  if (f.fbq) return;
  const n: any = f.fbq = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
  };
  if (!f._fbq) f._fbq = n;
  n.push = n;
  n.loaded = true;
  n.version = '2.0';
  n.queue = [];
  const t = b.createElement(e);
  t.async = true;
  t.src = v;
  document.head.appendChild(t);
})(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
(window as any).fbq('init', '1501611034718587');
(window as any).fbq('track', 'PageView');
// Meta Pixel noscript fallback
const noscriptImg = document.createElement('img');
noscriptImg.height = 1;
noscriptImg.width = 1;
noscriptImg.style.display = 'none';
noscriptImg.src = 'https://www.facebook.com/tr?id=1501611034718587&ev=PageView&noscript=1';
document.body.appendChild(noscriptImg);
render(<BrowserRouter data-id="element-307">
    <App data-id="element-308" />
  </BrowserRouter>, document.getElementById('root'));